var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 18c-.39 0-.78-.132-1.097-.398L.617 9.03a1.713 1.713 0 112.194-2.633l9.208 7.673 9.192-7.397a1.715 1.715 0 012.15 2.671l-10.286 8.277A1.714 1.714 0 0112 18z"}));
}

ArrowDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
